var map = {
	"./images-alignccd/Cam_0000.jpg": 65271,
	"./images-alignm1/Cam_0000.jpg": 89754,
	"./images-alignm2/Cam_0000.jpg": 54153,
	"./images-calibratemic/Cam_0000.jpg": 32654,
	"./images-ccdshutter/Cam_0000.jpg": 98763,
	"./images-focusdemo/Cam_0000.jpg": 65515,
	"./images-refrachelium/Cam_0000.jpg": 15495,
	"./images-refracxenon/Cam_0000.jpg": 37639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45476;